
var prefix = '/api';

export const API_ANALYZE_SELFIE = prefix + '/selfie/analyze/';
export const API_REDIRECT_URL = prefix + '/selfie/redirect-url/';
export const API_VERIFY_AUTH = prefix + '/selfie/verify-auth/';
